// components/SwEventDrawer/hooks/useEventFormValidation.js
import * as Yup from "yup";

export const useEventFormValidation = () => {
  // Fixed validation schema - removed cyclic dependency
  const validationSchema = Yup.object({
    event_name: Yup.string()
      .min(2, "Event name must be at least 2 characters")
      .max(100, "Event name must be less than 100 characters")
      .required("Event name is required"),
    location: Yup.string()
      .min(2, "Location must be at least 2 characters")
      .max(200, "Location must be less than 200 characters")
      .required("Location is required"),
    start_date: Yup.date()
      .required("Start date is required")
      .min(new Date(), "Start date cannot be in the past"),
    end_date: Yup.date()
      .required("End date is required")
      .min(Yup.ref('start_date'), "End date must be after start date"),
    ticketTypes: Yup.array()
      .of(
        Yup.object().shape({
          accessType: Yup.string()
            .test('required-with-price', 'Access type is required when price is provided', function(value) {
              const { price } = this.parent;
              if (price && price.toString().trim() !== '') {
                return value && value.trim() !== '';
              }
              return true;
            }),
          price: Yup.number()
            .test('required-with-access-type', 'Price is required when access type is provided', function(value) {
              const { accessType } = this.parent;
              if (accessType && accessType.trim() !== '') {
                return value && value > 0;
              }
              return true;
            })
            .test('positive-number', 'Price must be greater than 0', function(value) {
              if (value !== undefined && value !== null && value !== '') {
                return value > 0;
              }
              return true;
            }),
          description: Yup.string().max(500, "Description must be less than 500 characters")
        })
      )
      .test('at-least-one', 'At least one complete ticket type is required', function(value) {
        const completeTickets = value.filter(ticket => 
          ticket.accessType && ticket.accessType.trim() && 
          ticket.price && ticket.price > 0
        );
        return completeTickets.length > 0;
      }),
    accessSlots: Yup.object().test('valid-slots', 'Invalid slot configuration', function(value) {
      const { ticketTypes } = this.parent;
      const activeAccessTypes = ticketTypes
        .filter(ticket => ticket.accessType && ticket.accessType.trim() && ticket.price)
        .map(ticket => ticket.accessType);
      
      for (const accessType of activeAccessTypes) {
        const slots = value[accessType];
        if (!slots || parseInt(slots) <= 0) {
          return this.createError({
            path: `accessSlots.${accessType}`,
            message: `${accessType} slots must be greater than 0`
          });
        }
      }
      return true;
    }),
    paymentOption: Yup.string()
      .oneOf(['bankTransfer', 'card'], 'Please select a valid payment option')
      .required("Payment option is required")
  });

  return { validationSchema };
};
